import { createAction } from 'redux-actions'

export const getPagedAllFormsRequest = createAction('GET_PAGED_ALL_FORMS_REQUEST')
export const getPagedAllFormsSuccess = createAction('GET_PAGED_ALL_FORMS_SUCCESS')
export const getPagedAllFormsFailed = createAction('GET_PAGED_ALL_FORMS_FAILED')

export const resetAllFormsPage = createAction('RESET_ALL_FORMS_PAGE')
